export default "__VITE_ASSET__CMBiRyMg__"